<template>
  <div>
    <v-row class="row">
      <v-col cols="12">
        <div
            class="section-title section-title--2 text-center text-white mb--15 mb_sm--0"
        >
          <h3 class="heading-title">{{ title }}</h3>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <!-- Start Single Counterup  -->
      <v-col
          lg="4"
          md="4"
          sm="4"
          cols="12"
          v-for="(counter, i) in counterUpContent"
          :key="i"
      >
        <div class="rn-counterup counterup_style--1">
          <h5 class="counter count">
            <VisibilitySensor @change="onChange">
              <countTo
                  :endVal="status ? counter.endVal : 0"
                  :autoplay="countUp"
                  :duration="3000"
              ></countTo>
            </VisibilitySensor>
          </h5>
          <p class="description">
            {{ counter.desc }}
          </p>
        </div>
      </v-col>
      <!-- Start Single Counterup  -->
    </v-row>
  </div>
</template>

<script>
import VisibilitySensor from "vue-visibility-sensor";
import countTo from "vue-count-to";
import CounterOne from "@/components/counter/CounterOne.vue";
import {container} from "@/main";
import {HomeService} from "@/pages/home/home.service";

export default {
  components: {
    CounterOne,
    countTo,
    VisibilitySensor,
  },
  async created() {
    this.homeService = container.get(HomeService);
    const services = await this.homeService.getServices();
    const parser = new DOMParser();
    const doc = parser.parseFromString(services.content.rendered, 'text/html');
    this.title = doc.querySelector('.wp-block-heading').textContent;
    const columns = doc.querySelectorAll('.wp-block-group__inner-container > .wp-block-columns.alignwide.is-layout-flex');
    const results = [];
    columns.forEach(column => {
      const title = column.querySelector('.wp-block-heading').textContent.trim();
      const number = parseInt(column.querySelector('.wp-block-column:nth-child(2) p').textContent.trim());
      const description = column.querySelector('.wp-block-column:nth-child(3) p').textContent.trim();
      if (title && number && description) {
        results.push({ title, number, description });
      }
      return results;
    });
    this.counterUpContent = [];
    for(const column of results) {
      this.counterUpContent.push({
        endVal: column.number,
        desc: column.description,
      });
    }
  },
  data() {
    return {
      countUp: true,
      status: false,
      title: 'Servicios',
      counterUpContent: [
        {
          endVal: 992,
          desc: `The standard chunk of Lorem Ipsum used since the 1500s is reproduced
            below for those.`,
        },
        {
          endVal: 575,
          desc: `The standard chunk of Lorem Ipsum used since the 1500s is reproduced
            below for those.`,
        },
        {
          endVal: 69,
          desc: `The standard chunk of Lorem Ipsum used since the 1500s is reproduced
            below for those.`,
        },
      ],
    };
  },
  methods: {
    onChange(isVisible) {
      if (isVisible) {
        this.status = true;
      }
    },
  },
};
</script>
